import React from "react";
import OpportunityDetails from "./OpportunityDetails";
import ProductHeader from "./ProductHeader";
import OpportunityLinkSuccess from "./OpportunityLinkSuccess";

import styles from "./OpportunityLinkView.module.scss";
import ProductDetails from "./ProductDetails";
import className from "classnames";


function OpportunityLinkView({
  location,
  opportunity,
  onAlertOpen,
  opportunityApplied,
  currentUser,
  logout
}) {
  const { product } = opportunity;
  if (opportunityApplied)
    return (
      <div className={styles.opportunityLinkSuccess}>
        <OpportunityLinkSuccess
          product={opportunity.product}
          brand={opportunity.product.owner}
          opportunityVisibility={opportunity.visibility}
        />
      </div>
    );
  else
    return (
      <div className={'container'}>
      <div className={className(styles.oppLinkView)}>
        <ProductHeader product={opportunity.product} />
        <div className={styles.details}>
          <ProductDetails product={opportunity.product} />
          <OpportunityDetails
            currentUser={currentUser}
            opportunityDetails={opportunity}
            location={location}
            logout={logout}
            onAlertOpen={onAlertOpen}
          />
        </div>
        <div className={styles.brandInfo}>
          {product.owner && <div>
            <h3>Brand Info</h3>
            <p>{product.owner.bio}</p>
            <a href={`http://${product.owner.website}`} target={'_blank'} className={styles.website}>{product.owner.website}</a>
          </div>}
        </div>
        </div>
      </div>
    );
}

export default OpportunityLinkView;
